import{ReligionlistComponent}from '../components/Religion/religionlist.component';
import { Injectable,Component } from '@angular/core';
import { HttpHeaders}  from '@angular/common/http';  
import { Observable,throwError  } from 'rxjs';  
import { HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { DataAccessService } from '../../shared/services/dataaccess.service';

export class GridColumns {
  caption: string;
  dataField: string;
  dataType: string;
  cssClass: string;
  allowSorting: boolean;
};
export class Religion {
  ReligionID:number;
  ReligionDescription: string;
  ReligionShortName: string;
  ReligionCode:string;
  Separatebox:boolean;
  AddInfo: string;
  CreatedLoginID:number;
  UpdatedLoginID:number;
} 
let gridColumns: GridColumns[] = [
{
  "caption": 'Name',
  "dataField": "ReligionDescription",
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
},
{
  "caption": 'Short Name',
  "dataField": "ReligionShortName",
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
}, 
{
  "caption": 'Code',
  "dataField": "ReligionCode",
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
},
{
  "caption": 'Separate Box',
  "dataField": "AddInfo",
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
},
];

Injectable(
  {  
    providedIn: 'root'  
  }
)
@Component({
  providers: [DataAccessService]
})

export class ReligionService {
  constructor(
    private dataService: DataAccessService) {
  }
  public ReligionData: Religion;
  public errormsg;
  public successmsg;
  public getAllReligion() {
    this.dataService.setControllerName = '/BasicReligion/';
    this.dataService.setMethodName = 'GetBasicReligionList?ReligionID=0'; // setting method name from API controller.
    return this.dataService.getAll<Religion[]>()
  } 
  public getReligionByID() {
    this.dataService.setControllerName = '/BasicReligion/';
    this.dataService.setMethodName = 'GetBasicReligionList';
    this.dataService
      .getSingle<Religion>('?ReligionID=0')    
      .subscribe((data: Religion) => this.ReligionData = data,
        error => () => {
        },
        () => {
              return this.ReligionData;
        });
  }
  public save(data) {
    this.dataService.setControllerName = '/BasicReligion/';
    this.dataService.setMethodName = 'PostInsertBasicReligion'; // setting method name from API controller.
    return this.dataService.add<Religion[]>(data) 
  }
  public update(data) {
    this.dataService.setControllerName = '/BasicReligion/';
    this.dataService.setMethodName = 'PostBasicReligion'; // setting method name from API controller.
    return this.dataService.add<Religion[]>(data)
  }
  public delete(data) {
    this.dataService.setControllerName = '/BasicReligion/';
    this.dataService.setMethodName = 'PostDeleteBasicReligion'; // setting method name from API controller.
    return this.dataService.delete<Religion[]>(data)
  }
 
  getGridColumns() {
    return gridColumns;
  } 
}
